<template>
  <div>
    <div class="level">
      <div class="level-left">
        <selecteur-action
          @handleAction="manageActions"
          :options='actions'
          :placeholder='$t("general.placeHolder.groupedAction")'
          :titleButton="'general.button.apply'"
          :elementsSelectionnes="hasDispositifSelected">
      </selecteur-action>
      </div>
      <div class="level-right">
        <router-link
          :to="{ name: 'm.gabed.emplacement-dispositifPublicitaire',
            params: { id: $route.params.id }}"
          class="button is-addOrEdit"
          :class="{'button-access-no-permission':
            !checkPermissions(constantes.permEmplacement.maj)}">
          {{$t('detailEmplacement.ajoutDispositif')}}
        </router-link>
      </div>
    </div>
    <v-client-table
      :data="dispositifs"
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      class="displayNoneVuePagination"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering">
      <template slot="selected" slot-scope="props" >
        <div class="has-text-centered">
          <qd-checkbox :value="props.row.selected"
            @input="updateSelected(props.row)"/>
        </div>
      </template>
      <template slot="code" slot-scope="props">
        <router-link :to="getDetailsRoute(props.row)"
                     class="lien"
                     :class="{'text-access-no-permission':
                     !checkPermissions(constantes.permEmplacement.lecture)}">
          {{ props.row.code }}
        </router-link>
      </template>
      <template slot="dispositifType.libelle" slot-scope="props">
        {{ getDispositifTypeLibelle(props.row.dispositifTypeId) }}
      </template>
      <template slot="adresse" slot-scope="props">
        {{ props.row.adresse | adresse }}
      </template>
      <template slot="etat" slot-scope="props">
        {{ $t(getEtatMontage(props.row.etat)) }}
      </template>
      <template slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.emplacement.agenceId) }}
      </template>
      <template slot="actif" slot-scope="props">
        {{ props.row.actif ? $t('general.non') : $t('general.oui') }}
      </template>
      <template slot="dispositifSupport.libelle" slot-scope="props">
        {{ props.row.dispositifSupport ? props.row.dispositifSupport.libelle : '' }}
      </template>
      <template slot="actions" slot-scope="props">
        <verticalDotsDropdown
          :dropdownItems="dropdownItems(props.row)"
          :isButton="false"/>
      </template>
    </v-client-table>
    <b-modal v-model="openPopUpPrevention"
             has-modal-card
             class="modal" @close="dispositifsToArchive = []">
      <pop-up-prevention
        @no="openPopUpPrevention = false; dispositifsToArchive = []"
        @yes="archiverDispositif"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="$t(('listeDispositif.archivageDesarchiver.'
        + (isDispositifsToArchiveActif ? 'archivage' : 'desarchivage')))"
        :mess-footer="$t(('listeDispositif.infoArchivageDesarchivage.'
        + (isDispositifsToArchiveActif ? 'archivage' : 'desarchivage')))">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="popUpDupliquer" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('dispositifPublicitaire.popUpPreventionCopy.message')"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVide"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @yes="dupliquerDispositif"
        @no="popUpDupliquer = false"
      />
    </b-modal>
    <b-modal v-model="popUpChangementEtatEnMasse" has-modal-card
             class="modal">
      <pop-up-update-etat
        :messHeader="$t('dispositifPublicitaire.popUpSave.titleDemonte')"
        :dispositifs="allDispositfsSelected"
        :etat="constantes.DEMONTE"
        @validate="validationPopUp">
      </pop-up-update-etat>
    </b-modal>
    <b-modal v-model="openPopUpDeplacer" has-modal-card
      class="modal">
      <pop-up-deplacer-dispositif
        :dispositif="dispositifADeplacer"
        @deplacer="deplacerDispositif">
      </pop-up-deplacer-dispositif>
    </b-modal>
    <b-modal
      v-model="openPopUpPreventionSuppression"
      has-modal-card
      class="modal">
      <pop-up-prevention
        @no="openPopUpPreventionSuppression = false"
        @yes="supprimerDispositif"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="$t('dispositifPublicitaire.supprimer.titre')"
        :mess-footer="$t('dispositifPublicitaire.supprimer.sousTitre')">
      </pop-up-prevention>
    </b-modal>
  </div>
</template>

<script>

import {
  NO_PER_PAGE_VALUE, RESULTS_PER_PAGE, SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import { createNamespacedHelpers } from 'vuex';
import verticalDotsDropdown from '@/components/general/button/verticalDotsDropdown';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import validationDispositif from '@/services/gabed/dispositif/validation';
import { REFERENCE_TABLE_DISPOSITIF } from '@/configuration/general/referenceTableConf';
import messageErreur from '@/services/general/messageErreur';
import { columnsSplice } from '@/services/general/columns';
import selecteurAction from '@/components/general/selecteurAction';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import {
  ACTION_MASS_DEMONTER,
  ACTION_MASS_ARCHIVER,
} from '@/configuration/general/actionsConf';
import {
  ETAT_DISPOSITIF_PUBLICITAIRE,
  DEMONTE,
} from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import {
  getAll,
  dupliquerAsync,
  archiverAll,
  supprimer,
} from '@/api/gabed/dispositif';
import cloneDeep from 'lodash/cloneDeep';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import popUpUpdateEtat from '@/components/general/popUpUpdateEtat';
import validationPatrimoine from '@/services/gabed/patrimoine/validationPatrimoine';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/gabed/emplacement/validation/champsEmplacementTranslator';
import popUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import popUpDeplacerDispositif from '@/components/gabed/dispositif/popUpDeplacerDispositif';
import validationSuppression from '@/services/gabed/dispositif/validationSuppression';

const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      dispositifs: [],
      popUpChangementEtatEnMasse: false,
      idDispositif: null,
      popUpDupliquer: false,
      champsVide: [],
      messagesChampsVide: [],
      errorPopUp: false,
      errors: [],
      messagesErreurPopUp: [],
      constantes: {
        permEmplacement: EMPLACEMENT,
        DEMONTE,
      },
      referenceTable: REFERENCE_TABLE_DISPOSITIF,
      startArrayRendering: false,
      dispositifsToArchive: [],
      openPopUpPrevention: false,
      actions: [
        {
          action: ACTION_MASS_ARCHIVER,
          translation: 'listeDispositif.actions.archivageDispositif',
        },
        {
          action: ACTION_MASS_DEMONTER,
          translation: 'listeDispositif.actions.demonter',
        },
      ],
      openPopUpDeplacer: false,
      dispositifADeplacer: null,
      openPopUpPreventionSuppression: false,
    };
  },
  components: {
    selecteurAction,
    popUpUpdateEtat,
    verticalDotsDropdown,
    popUpPrevention,
    popUpDeplacerDispositif,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
    }),
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
    columns() {
      const columns = ['selected', 'code', 'nom', 'dispositifType.libelle', 'dispositifSupport.libelle', 'etat', 'adresse', 'actif', 'agence', 'actions'];
      if (this.societeActive.agences.length === 1) {
        columnsSplice(columns, 'agence');
      }
      if (!this.moduleEmplacementClientActive) {
        columnsSplice(columns, 'nom');
      }
      return columns;
    },
    hasDispositifSelected() {
      return this.dispositifs.some(d => d.selected);
    },
    hasAllDispositfsSelected() {
      return this.dispositifs.length > 0 && this.dispositifs.every(d => d.selected);
    },
    allDispositfsSelected() {
      return this.dispositifs.filter(d => d.selected);
    },
    iconSelectTotal() {
      if (this.hasAllDispositfsSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    isDispositifsToArchiveActif() {
      return this.dispositifsToArchive.some(d => d.actif);
    },
    options() {
      const texts = cloneDeep(TEXTS);
      return {
        sortIcon: SORT_ICON,
        headings: {
          code: this.$i18n.t('listeDispositif.tab.code'),
          nom: this.$i18n.t('listeDispositif.tab.nom'),
          'dispositifType.libelle': this.$i18n.t('listeDispositif.tab.type'),
          'dispositifSupport.libelle': this.$i18n.t('listeDispositif.tab.support'),
          etat: this.$i18n.t('listeDispositif.tab.etatMontage'),
          adresse: this.$i18n.t('listeDispositif.tab.adresse'),
          agence: this.$i18n.t('listeMateriel.tab.agence'),
          actif: this.$i18n.t('listeDispositif.tab.archive'),
          actions: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          selected: 'colonneSelected',
          actions: 'colonneSelected',
        },
        sortable: ['code', 'nom', 'dispositifType.libelle', 'dispositifSupport.libelle', 'etat', 'adresse'],
      };
    },
  },
  filters: {
    adresse(adresse) {
      return adressFullStringGetter(adresse);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    updateSelected(row) {
      const dispositif = this.dispositifs.find((d) => d.id === row.id);
      dispositif.selected = !dispositif.selected;
    },
    selectAll() {
      const select = !this.hasAllDispositfsSelected;
      this.dispositifs.forEach((dispositif) => {
        if (dispositif.selected !== undefined) dispositif.selected = select;
      });
    },
    manageActions(action) {
      switch (action) {
        case ACTION_MASS_ARCHIVER:
          if (this.checkPermissions(this.constantes.permEmplacement.maj)) {
            this.showPopUpArchivage(this.allDispositfsSelected);
          } else this.showPopUp();
          break;
        case ACTION_MASS_DEMONTER:
          if (this.checkPermissions(this.constantes.permEmplacement.maj)) {
            this.popUpChangementEtatEnMasse = true;
          } else this.showPopUp();
          break;
        default:
          messageErreur(this.$i18n, this.$i18n.t('listeFace.errors.noActionSelect'));
          break;
      }
    },
    getDetailsRoute(dispositif) {
      return {
        name: 'c.gabed.emplacement-detailDispositif',
        params: {
          idDispositif: dispositif.id,
        },
      };
    },
    getAgenceLibelle(agenceId) {
      const agence = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      return agence ? agence.libelleAgence : '';
    },
    async validationPopUp() {
      this.popUpChangementEtatEnMasse = false;
      await this.loadDispositifs();
    },
    getDispositifTypeLibelle(id) {
      const dispositifFind = this.parametre(PARAMETRES_KEYS.dispositifType).find((dispositif) => {
        return dispositif.id === id;
      });
      return dispositifFind ? dispositifFind.libelle : '';
    },
    getEtatMontage(codeEtat) {
      const etatFind = ETAT_DISPOSITIF_PUBLICITAIRE.find((etat) => {
        return etat.value === codeEtat;
      });
      return etatFind ? etatFind.libelle : null;
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    showPopUpArchivage(dispositifsToArchive) {
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
      this.openPopUpPrevention = true;
      this.dispositifsToArchive = dispositifsToArchive;
    },
    async archiverDispositif() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        const ids = this.dispositifsToArchive.map(d => d.id);
        const actif = this.isDispositifsToArchiveActif;
        await archiverAll(ids, actif);
        messageSucces(this.$i18n.t('listeDispositif.messages.success.' + (this.isDispositifsToArchiveActif ? 'archivage' : 'desarchivage')));
        await this.loadDispositifs();
        this.openPopUpPrevention = false;
        this.dispositifsToArchive = [];
      } catch (e) {
        if (e.response) {
          validationDispositif(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async dupliquerDispositif() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        this.champsVide = [];
        this.messagesChampsVide = [];
        await dupliquerAsync(this.idDispositif);
        messageSucces(this.$t('dispositifPublicitaire.popUpPreventionCopy.success'));
        this.popUpDupliquer = false;
        await this.loadDispositifs();
      } catch (e) {
        if (e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide, this.messagesErreurPopUp,
            this.messagesChampsVide, translate);
          validationPatrimoine(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    demonteOneElem(dispositif) {
      if (!dispositif.selected) {
        this.updateSelected(dispositif);
      }
      this.popUpChangementEtatEnMasse = true;
    },
    dropdownItems(row) {
      return [
        {
          action: () => { this.showPopUpArchivage([row]); },
          libelle: this.$i18n.t('listeDispositif.actions.'
           + (row.actif ? 'archiverDispositif' : 'desarchiverDispositif')),
          permission: this.constantes.permEmplacement.supprimer,
        },
        {
          action: () => {
            this.idDispositif = row.id;
            this.messagesErreurPopUp = [];
            this.errorPopUp = false;
            this.popUpDupliquer = true;
          },
          libelle: this.$t('general.button.dupliquer'),
          id: 0,
          permission: this.constantes.permEmplacement.maj,
        },
        {
          action: () => { this.demonteOneElem(row); },
          libelle: this.$i18n.t('listeDispositif.actions.demonter'),
          permission: this.constantes.permEmplacement.maj,
        },
        {
          action: () => {
            this.dispositifADeplacer = row;
            this.openPopUpDeplacer = true;
          },
          libelle: this.$t('detailEmplacement.popupDeplacerDispositif.deplacer'),
          permission: this.constantes.permEmplacement.maj,
        },
        {
          action: () => {
            this.idDispositif = row.id;
            this.messagesErreurPopUp = [];
            this.errorPopUp = false;
            this.openPopUpPreventionSuppression = true;
          },
          libelle: this.$t('general.button.delete'),
          permission: this.constantes.permEmplacement.supprimer,
        },
      ];
    },
    async loadDispositifs() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const dataBody = {
          query: {
            emplacementId: this.$route.params.id,
            societeId: this.societeActiveId,
          },
        };
        this.dispositifs = (await getAll(dataBody)).data.result.items;
        this.dispositifs.forEach(dispositif => {
          this.$set(dispositif, 'selected', false);
        });
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    async deplacerDispositif() {
      this.openPopUpDeplacer = false;
      await this.loadDispositifs();
    },
    async supprimerDispositif() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        await supprimer(this.idDispositif);
        messageSucces(this.$t('dispositifPublicitaire.messages.success.supprimer'));
        this.openPopUpPreventionSuppression = false;
        await this.loadDispositifs();
      } catch (e) {
        if (e.response.data.error) {
          validationSuppression(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadDispositifs();
      await this.loadParametres([PARAMETRES_KEYS.dispositifType]);
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key,
      ]);
      this.startArrayRendering = true;
    } catch (e) {
      messageErreur(this.$i18n);
      throw (e);
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
